// SG region: everything that differs for this site. Registered in ../regionConfig.js.
export const config = {
  code: 'SG',
  sourceSite: 'digirep-sg',
  currency: 'SGD',
  supportEmail: 'hello@digitalreporting.sg',
  careEmail: 'hello@digitalreporting.sg',
  moneyPrefix: 'S$',
  referralReward: 50,
  companyIdLabel: 'UEN',
  filingServicesLabel: 'ACRA Filing Services',
  searchProviderLabel: 'Manual UEN entry',
  filingStatusLabels: {
    ch: 'ACRA',
    hmrc: 'IRAS',
  },
  phonePlaceholder: '+65 8123 4567',
  signupSubtitle: 'Singapore ACRA XBRL managed filing services',
  primaryService: 'acra_xbrl',
  accountTypes: [
    { value: 'sg_simplified_xbrl', label: 'Simplified XBRL', subtitle: 'Smaller non-public entities', price: 25 },
    { value: 'sg_full_xbrl_standalone', label: 'Full XBRL', subtitle: 'Standalone accounts', price: 50 },
    { value: 'sg_full_xbrl_consolidated', label: 'Full XBRL', subtitle: 'Consolidated accounts', price: 75 },
  ],
  optionalServices: [
    {
      id: 'acra_simple_xbrl_filing',
      title: 'ACRA BizFin Portal Simple XBRL Filing',
      description: 'We submit your Simple XBRL package through the ACRA BizFin Portal',
      price: 15,
    },
    {
      id: 'acra_full_xbrl_filing',
      title: 'ACRA BizFin Portal Full XBRL Filing',
      description: 'We submit your Full XBRL package through the ACRA BizFin Portal',
      price: 20,
    },
  ],
  serviceCatalog: {
    acra_xbrl: { title: 'ACRA XBRL Preparation', price: 0 },
    acra_simple_xbrl_filing: { title: 'ACRA BizFin Portal Simple XBRL Filing', price: 15 },
    acra_full_xbrl_filing: { title: 'ACRA BizFin Portal Full XBRL Filing', price: 20 },
  },
  delivery: {
    standard: { label: 'Standard (48 hours)', shortLabel: 'Standard', hours: '48h', surcharge: 0 },
    express: { label: 'Express (24 hours)', shortLabel: 'Express', hours: '24h', surcharge: 25 },
  },
};

// Hostnames that identify this region and the host used for links back to it.
export const hosts = ['xbrl.digitalreporting.sg', 'preview.digitalreporting.sg'];
export const primaryHost = 'xbrl.digitalreporting.sg';
